import type { GridValueFormatterParams } from "@mui/x-data-grid";
import { UiDateTimeFormatter, formatDate } from "util/formaters";

const dateFormater = ({ value }: GridValueFormatterParams<string>) =>
    formatDate(value, { pattern: UiDateTimeFormatter.Default });

export default dateFormater;
